import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";

import TopNavBar from "../../TopNavBar";
import Sidebar from "./Sidebar";
import Footer from "../../../components/footer";

// import socket from "../../../utils/socket";

// import App_Routes from "../../../routes/appRoutes";
import PRODADeviceExpiryReminder from "../../PRODAInterface/PRODADeviceExpiryReminder";
import CertificatesExpiryReminder from "../../CertificateInterface/CertificatesExpiryReminder";

import SocketHandler from "../../SocketHandler";

// import DingBell from "../../../assets/audios/note_sms.mp3";
import {
  // updateChatSoundStatus,
  updateConsultNatureList,
  updateDoctorAndNurseList, updateSupportStaff,
  // updateSupportTickets,
  // updateUnreadChatCountAdmin
} from "../../../reduxStore/actions/serverConstants";
import MakeAPICall from "../../../apiCalls/common";
import { doctorListForChat, getConsultsApiRoute, getSupportStaffApiRoute } from "../../../apiRoutes";
// import {get} from "lodash";

const DashboardLayout = props => {
  console.log("--------> serverConstants : ", props.serverConstants);
    const [doctorAndNurseListAPICall, setDoctorAndNurseListAPICall] = useState(null);
    const [staffSupportDataAPICall, setStaffSupportDataAPICall] = useState(null);
    const [consultNatureAPICall, setConsultNatureAPICall] = useState(null);

    const getDoctorList = ()=> {
        setDoctorAndNurseListAPICall({
            reqType: "GET",
            reqUrl: doctorListForChat,
            params: {},
            successCallback: async res => {
                let allDocNurse = res.data.data.doctorData;
                // res.data.data.doctorData.concat(
                //   res.data.data.nurseData
                // );
                // Sidebar.hasCalledDoctorAndNurseAPI = true;
                props.updateDoctorAndNurseList(allDocNurse);
                // this.setState({
                //     allDoctorList: allDocNurse
                // });
            },
            failureCallback: err => {
                console.log("Got some error here : ", err);
            }
        });
    }

    const getStaffList = ()=> {
        setStaffSupportDataAPICall( {
            reqType: "GET",
            reqUrl: getSupportStaffApiRoute,
            params: {
                skip: 0,
                limit: 0
            },
            successCallback: async res => {
                const staffList = [];
                await res.data.data.staffs.forEach(staff => {
                    if (staff.isBlocked === false) {
                        let staffName = '';
                        if (staff.firstName === "System" && staff.lastName === "System") {
                            staffName = 'Instant Consult';
                        } else {
                            staffName = staff.firstName + " " + staff.lastName;
                        }
                        staffList.push({
                            id: staff._id,
                            name: staffName
                        });
                    }
                });
                props.updateSupportStaff(staffList);
            },
            failureCallback: err => {}
        });
    }

  // get consult nature list
  const getConsultNatureList = () => {
    setConsultNatureAPICall({
      reqType: "GET",
      reqUrl: getConsultsApiRoute,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        await res.data.data.consultData.forEach(column => {
          let d = {};
          d._id = column._id;
          if (column.consultName && column.consultName !== "") {
            d.consultName = column.consultName;
          } else {
            d.consultName = "";
          }
          list.push(d);
        });

        props.updateConsultNatureList(list);
      },
      failureCallback: err => {
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    askForLeavePage();
    getDoctorList();
    getStaffList();
    getConsultNatureList();
  }, []);


  const askForLeavePage = () => {
    console.log("Ask For Leave on close");
    window.onbeforeunload = e => {
      e = e || window.event;

      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = "Sure?";
      }

      // For Safari
      return "Sure?";
    };
  };

  return (
    <Fragment>
      <div className="main-content d-flex flex-column">
        <TopNavBar />
        <PRODADeviceExpiryReminder />
        <CertificatesExpiryReminder />
        <div className="container-fluid flex-grow-1 d-flex flex-row pl-0 container-margin-top">
          <div className="sidebar-container mt-4">
            <Sidebar />
          </div>
          <div className="page-content-conatiner container mt-4 ml-4 position-relative">
            {props.children}
          </div>
        </div>
        <Footer
          privacyPolicyLink={
            props.serverConstants ? props.serverConstants.privacyPolicy : "#"
          }
        />
      </div>
        <MakeAPICall apiParam={doctorAndNurseListAPICall}/>
        <MakeAPICall apiParam={staffSupportDataAPICall}/>
        <MakeAPICall apiParam={consultNatureAPICall}/>

      <SocketHandler />
    </Fragment>
  );
};

const mapStateToProps = state => ({
  serverConstants: state.serverConstants.constants
  // isMuted: state.serverConstants.isMuted
});

const mapDispatchToProps = dispatch => ({
    updateDoctorAndNurseList: data => dispatch(updateDoctorAndNurseList(data)),
    // updateSupportTickets: data => dispatch(updateSupportTickets(data)),
    updateSupportStaff: data => dispatch(updateSupportStaff(data)),
    updateConsultNatureList: data => dispatch(updateConsultNatureList(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayout);

// import React, { Fragment } from "react";
// import { connect } from "react-redux";

// import TopNavBar from "../../TopNavBar";
// import Sidebar from "./Sidebar";
// import Footer from "../../../components/footer";

// const DashboardLayout = props => (
//   <Fragment>
//     <div className="main-content d-flex flex-column">
//       <TopNavBar />
//       <div className="container-fluid flex-grow-1 d-flex flex-row pl-0">
//         <div className="sidebar-container mt-4">
//           <Sidebar />
//         </div>
//         <div className="page-content-conatiner container mt-4 ml-4 position-relative">
//           {props.children}
//         </div>
//       </div>
//       <Footer
//         privacyPolicyLink={
//           props.serverConstants ? props.serverConstants.privacyPolicy : "#"
//         }
//       />
//     </div>
//   </Fragment>
// );

// const mapStateToProps = state => ({
//   serverConstants: state.serverConstants.constants
// });

// export default connect(mapStateToProps, null)(DashboardLayout);
